<div class="contacts-list-container">
  <!-- Search input -->
  <div *ngIf="!!searchControl" class="search-container">
    <div class="search-container__label">
      {{ inputLabel || ('shared.shareContact.shareWith' | xTranslate) }} <span class="required-icon"> * </span>
    </div>
    <div class="searchContainer">
      <input type="text" autocomplete="no-autofill" class="searchBox" [formControl]="searchControl" />
      <em class="fa fa-search searchIcon search-container__input-icon"></em>
    </div>
  </div>

  <!-- List of contacts -->
  <div *ngIf="contactList.length; else emptyContactList" class="list-of-contacts-container">
    <ng-container *ngFor="let contact of contactList">
      <miq-contact-card
        [user]="contact.user"
        [selected]="contact.isSelected"
        [isOnMIQ]="contact.isOnMIQ"
        (change)="onSelectionChange($event)"
      ></miq-contact-card>
    </ng-container>
  </div>

  <!-- Empty message -->
  <ng-template #emptyContactList>
    <div class="empty-contact-list-msg">{{ 'shared.shareContact.noUserFound' | xTranslate }}</div>
  </ng-template>
</div>
